import { useTheme } from "@mui/material";

export const useInvalidRowStyle = () => {
  const theme = useTheme();

  return (isInvalid: boolean) => ({
    backgroundColor: isInvalid ? theme.palette.error.main + "11" : "inherit",
    border: isInvalid ? `1px solid ${theme.palette.error.main}` : undefined,
  });
};
